import React from 'react';

import { Icon } from '@chakra-ui/react';

export const AWSQIcon = props => (
  <Icon viewBox="0 0 720 720" w="full" h="full" color="inherit" {...props}>
    <g transform="translate(-280 0)">
      <g>
        <path
          d="M6760.17 3763.5 6760.17 3803.06 6728.65 3818.81 6697.1 3803.06 6697.1 3763.5 6728.65 3747.67 6760.17 3763.5ZM6938.49 3931.06 6749.32 4038C6736.57 4045.21 6720.71 4045.21 6707.96 4038L6518.82 3931.06C6505.61 3923.63 6497.45 3909.6 6497.45 3894.5L6497.45 3670.94C6497.45 3656.38 6505.18 3642.63 6517.62 3635.05L6706.8 3519.92C6713.52 3515.82 6721.07 3513.74 6728.65 3513.74 6736.2 3513.74 6743.76 3515.82 6750.51 3519.92L6939.65 3635.05C6952.1 3642.63 6959.83 3656.38 6959.83 3670.94L6959.83 3894.5C6959.83 3897.1 6959.49 3899.67 6959.04 3902.17L6781.17 3803.37 6781.17 3756.99C6781.17 3753.05 6778.94 3749.41 6775.4 3747.61L6733.36 3726.51C6730.4 3725.02 6726.91 3725.02 6723.92 3726.51L6681.88 3747.61C6678.33 3749.41 6676.1 3753.05 6676.1 3756.99L6676.1 3809.54C6676.1 3813.52 6678.33 3817.16 6681.91 3818.96L6723.95 3839.96C6725.41 3840.7 6727.03 3841.06 6728.65 3841.06 6730.24 3841.06 6731.86 3840.7 6733.33 3839.96L6770.41 3821.44 6950.11 3921.25C6946.9 3925.13 6943.02 3928.53 6938.49 3931.06ZM6950.57 3617.1 6761.43 3501.97C6741.19 3489.65 6716.09 3489.65 6695.85 3501.97L6506.71 3617.1C6488.03 3628.47 6476.44 3649.11 6476.44 3670.94L6476.44 3894.5C6476.44 3917.18 6488.7 3938.22 6508.45 3949.37L6697.62 4056.28C6707.19 4061.69 6717.92 4064.38 6728.65 4064.38 6739.38 4064.38 6750.11 4061.69 6759.65 4056.28L6948.82 3949.37C6968.57 3938.22 6980.86 3917.18 6980.86 3894.5L6980.86 3670.94C6980.86 3649.11 6969.25 3628.47 6950.57 3617.1Z"
          stroke="currentColor"
          strokeWidth="23.7773"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeMiterlimit="8"
          strokeOpacity="1"
          fill="currentColor"
          fillRule="evenodd"
          fillOpacity="1"
          transform="matrix(1 0 0 1.00171 -6088.65 -3418.81)"
        />
      </g>
    </g>
  </Icon>
);
